import { fb } from "../firebase";
import { firestore } from "../firebase";

const state = {
  user: {
    email: "",
    id: ""
  },
  userData: {
    name: "",
    phone: "",
    address: "",
    postCode: ""
  }
};

const getters = {
  getUser(state) {
    return state.user;
  },
  getUserData(state) {
    return state.userData;
  }
};

const mutations = {
  setUser(state, payload) {
    state.user = payload;
  },
  setUserData(state, payload) {
    state.userData = payload;
  }
};

const actions = {
  signUp({ commit }, payload) {
    fb.auth()
      .createUserWithEmailAndPassword(payload.email, payload.password)
      .then(res => {
        commit("setUser", { email: res.user.email, id: res.user.uid });
        console.log(res);
        firestore
          .collection("users")
          .doc(res.user.uid)
          .set({
            name: payload.name
          })
          .then(function() {
            commit("setUserData", payload);
            console.log("Document successfully written!");
          })
          .catch(function(error) {
            console.error("Error writing document: ", error);
          });
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode == "auth/weak-password") {
          alert("The password is too weak.");
        } else {
          alert(errorMessage);
        }
        console.log(error);
      });
  },
  signIn({ commit }, payload) {
    fb.auth()
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then(res => {
        commit("setUser", { email: res.user.email, id: res.user.uid });
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode === "auth/wrong-password") {
          alert("Wrong password.");
        } else {
          alert(errorMessage);
        }
        console.log(error);
      });
  },
  signOut({ commit }) {
    fb.auth()
      .signOut()
      .then(res => {
        console.log(res);
        console.log("successfully signed out");
        commit("setUser", {});
      })
      .catch(err => {
        console.log(err);
        console.log("failed to signed out");
      });
  },
  autoSignIn({ commit }) {
    let user = fb.auth().currentUser;
    if (user) {
      commit("setUser", { email: user.email, id: user.uid });
      firestore
        .collection("users")
        .doc(user.uid)
        .get()
        .then(res => {
          console.log(res.data());
          commit("setUserData", res.data());
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  setUserData({ commit }, payload) {
    commit("setUserData", payload);
  },
  changeUserEmailAndPassword({ commit }, payload) {
    var user = fb.auth().currentUser;

    user
      .updatePassword(payload.password)
      .then(function() {
        console.log("password updated successfully");
        user
          .updateEmail(payload.email)
          .then(function() {
            console.log("email updated successfully");
            commit("setUser", payload);
          })
          .catch(function(error) {
            console.log(error);
          });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
